import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import { listPortalsSuperPortal } from '~/state/ducks/organizations/operations';

import Search from '~/views/common/Search/containers/SystemPortalList';
import Heading from '~/views/common/Heading';


const filters = [];


const SystemPortals = () => (
    <Fragment>
        <Helmet title="System Portals" />

        <Heading
            header="System Portals"
            subheader="List"
            iconName="university"
        />

        <Search
            onSubmit={listPortalsSuperPortal}
            filters={filters}
            systemPortalList
        />
    </Fragment>
);

export default SystemPortals;
